var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-10" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "infinite-scroll",
            rawName: "v-infinite-scroll",
            value: _vm.getList,
            expression: "getList",
          },
        ],
        staticClass: "p-30 bg-white box",
        staticStyle: { overflow: "auto" },
      },
      [
        _c(
          "el-timeline",
          [
            _vm._l(_vm.list, function (pitem) {
              return _vm._l(pitem, function (item) {
                return _c(
                  "el-timeline-item",
                  {
                    attrs: {
                      timestamp: _vm.parseTime(
                        item.add_date,
                        "{y}-{m}-{d} {h}:{i}"
                      ),
                      placement: "top",
                    },
                  },
                  [
                    _c("el-card", [
                      _c("div", { staticClass: "fs-c1" }, [
                        _vm._v(_vm._s(item.title)),
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        domProps: { innerHTML: _vm._s(item.content) },
                      }),
                    ]),
                  ],
                  1
                )
              })
            }),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }